
import { UserRole } from '@/types/userRole';
import { isAuthenticated, getCurrentUser } from './auth/supabaseAuthService';

// Check if the current user is an admin
export const isAdmin = (role?: string): boolean => {
  if (!isAuthenticated()) return false;
  
  const user = getCurrentUser();
  const userRole = role || user?.role || localStorage.getItem('userRole');
  return userRole === 'admin' || localStorage.getItem('isAdmin') === 'true';
};

// Check if the current user is a super admin
export const isSuperAdmin = (role?: string): boolean => {
  if (!isAuthenticated()) return false;
  
  const user = getCurrentUser();
  const userRole = role || user?.role || localStorage.getItem('userRole');
  return userRole === 'superadmin' || localStorage.getItem('isSuperAdmin') === 'true';
};

// Check if the current user is a master admin
export const isMasterAdmin = (role?: string): boolean => {
  if (!isAuthenticated()) return false;
  
  const user = getCurrentUser();
  const userRole = role || user?.role || localStorage.getItem('userRole');
  return userRole === 'masterAdmin' || localStorage.getItem('isMasterAdmin') === 'true';
};

// Check if the current user is a full admin (admin, superadmin or masterAdmin)
export const isFullAdmin = (role?: string): boolean => {
  if (!isAuthenticated()) return false;
  
  const user = getCurrentUser();
  const userRole = role || user?.role || localStorage.getItem('userRole');
  return userRole === 'admin' || userRole === 'superadmin' || userRole === 'masterAdmin';
};

// Check if a user has admin privileges from localStorage
export const checkIsAdminFromLocalStorage = (): boolean => {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'admin' || 
         userRole === 'superadmin' || 
         userRole === 'masterAdmin' || 
         localStorage.getItem('isAdmin') === 'true' ||
         localStorage.getItem('isSuperAdmin') === 'true' ||
         localStorage.getItem('isMasterAdmin') === 'true';
};

// Get a user's subscription status
export const getSubscriptionStatus = (userId?: string): 'active' | 'inactive' | 'trial' => {
  // In a real app, this would check against a database
  return 'active';
};
